import { render, staticRenderFns } from "./authenticationError.vue?vue&type=template&id=2092fe72&scoped=true"
import script from "./authenticationError.vue?vue&type=script&lang=js"
export * from "./authenticationError.vue?vue&type=script&lang=js"
import style0 from "./authenticationError.vue?vue&type=style&index=0&id=2092fe72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2092fe72",
  null
  
)

export default component.exports